import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Format } from 'src/Components'
import { Heading, ProConList, Pro, Info } from 'src/Components/Gem/GemDetail'
import { avgSolarPanelInstallCost } from 'src/constants/equity'

const SolarPanelsDetail = ({ googleSunroofLink }) => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.solarPanelsHeading'
        defaultMessage='Adding solar panels to your home could be a great way to save on your electricity bill. A typical 5kw system costs around {solarPanelPrice}.'
        values={{
          solarPanelPrice: (
            <Format.Currency value={avgSolarPanelInstallCost} format='0,0a' />
          )
        }}
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.solarPanelsOne'
          defaultMessage='Claim a federal tax credit worth 30% of your total system cost'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.solarPanelsThree'
          defaultMessage='Solar systems also often qualify for state and utility company rebates'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.solarPanelsTwo'
          defaultMessage='Because it’s home improvement, the equity spent on solar can be tax-deductible (Always check with a professional tax advisor)'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.solarPanelsFour'
          defaultMessage='Depending on your roof size, shape, and amount of shade, {link}'
          values={{
            link: (
              <Button
                minimal
                element='a'
                href={googleSunroofLink}
                target='_blank'
              >
                <FormattedMessage
                  id='Homeowner.equity.solarPanelsLink'
                  defaultMessage='solar panels may not be practical'
                />
              </Button>
            )
          }}
        />
      </Info>
    </ProConList>
  </div>
)

export default SolarPanelsDetail
